module.exports = __webpack_public_path__ + "img/fakeTwo.804f59d2.png";